<template>
  <div id="app">
    <div class="login_box_all loginbox">
      <div class="login_box_content">
        <div>
          <!-- <div class="login_logo hidden-sm-and-down"></div> -->
          <div class="text-center login_title login_titleBox">
            <img src="../assets/images/login_logo.png" />
            《{{ $store.state.Name }}》 —
            <span class="highorange">修改密码</span>
          </div>
        </div>
        <div class="login_maxBox">
          <div class="container login_box center-block regist">
            <p style="color: #ff5f27">
              根据国家网络安全法要求，必须使用强密码（密码必须包含字母、数字、特殊字符3种形式；特殊字符仅包括.!@#_这5种西文字符；密码须8~16位）。请尽快修改。
            </p>
            <el-form
              ref="form"
              :model="form"
              label-width="100px"
              class="twenfive"
            >
              <el-form-item label="用户名:" :rules="[{ required: true }]">
                <el-col :md="14" :lg="14" :xl="14" :sm="14">
                  <el-input
                    v-model="form.user"
                    placeholder="请输入用户名"
                    @blur="DetectInput($event, 'user')"
                    @input="DetectKey($event, 'user')"
                  ></el-input>
                </el-col>
                <div class="clearfix"></div>
                <div class="five five msg_error" style="zoom: normal">
                  <span v-html="userTishi"></span>
                </div>
              </el-form-item>
              <div>
                <el-form-item label="Email:" :rules="[{ required: true }]">
                  <el-col :md="14" :lg="14" :xl="14" :sm="14">
                    <el-input
                      v-model="form.emails"
                      placeholder="请输入E-mail"
                      @blur="DetectInput($event, 'emails')"
                      @input="DetectKey($event, 'emails')"
                    ></el-input>
                  </el-col>
                  <el-col
                    :md="8"
                    :lg="8"
                    :xl="8"
                    :sm="8"
                    class="leftfloat ml1 myzm"
                    v-if="isshurus"
                  >
                    <el-button type="primary" plain @click="aaa()"
                      >验证邮箱是否可用</el-button
                    >
                  </el-col>
                  <div class="clearfix"></div>
                  <div class="five highgray five" style="zoom: normal">
                    <span>请填写账号绑定的邮箱。</span>
                  </div>
                  <div class="five five msg_error" style="zoom: normal">
                    <span v-html="EmailTiShi"></span>
                  </div>
                </el-form-item>
                <el-form-item
                  label="验证码:"
                  v-if="isShows"
                  :rules="[{ required: true }]"
                >
                  <el-col :md="14" :lg="14" :xl="14">
                    <el-input
                      v-model="form.picyzcodes"
                      placeholder="请输入图片验证码"
                      @blur="DetectInput($event, 'Piccodes')"
                      @input="DetectKey($event, 'Piccodes')"
                    ></el-input>
                  </el-col>
                  <el-col
                    :md="6"
                    :lg="6"
                    :xl="6"
                    :sm="6"
                    class="leftfloat ml1 myzm"
                  >
                    <span style="cursor: pointer">
                      <img
                        @click="initVeri()"
                        :src="'data:image/png;base64,' + Picturebase"
                        alt="无效"
                      />
                    </span>
                  </el-col>
                  <div class="clearfix"></div>
                  <div class="five five msg_error" style="zoom: normal">
                    <span v-html="picCodeTiShi"></span>
                    <span v-html="codeTiShis"></span>
                  </div>
                </el-form-item>
                <div class="clearfix"></div>
                <div v-if="isShows" class="twenfive">
                  <el-col
                    :md="8"
                    :lg="8"
                    :xl="8"
                    :sm="8"
                    class="leftfloat ml1 myzm"
                    v-if="iscodeBtna"
                  >
                    <el-button
                      class="five"
                      type="primary"
                      plain
                      @click="sendCodeBtn"
                      v-html="Btn1"
                      style="color: #fff"
                    ></el-button>
                  </el-col>
                  <el-col
                    :md="10"
                    :lg="10"
                    :xl="10"
                    :sm="10"
                    class="leftfloat ml1 myzm"
                  >
                    <el-button
                      class="five"
                      style="width: 100%"
                      v-if="status == 0"
                      @click="$router.push('/')"
                      >取消</el-button
                    >
                  </el-col>
                </div>
                <template v-if="status == 1">
                  <div class="twenfive" style="margin-top: 0px">
                    <div class="highgreen" v-if="status == 1">
                      系统已经发送验证码到填写的邮箱，若未收到验证码，请到邮件垃圾箱中查找一下。
                    </div>
                  </div>
                  <el-form-item
                    label="邮箱验证码:"
                    :rules="[{ required: true }]"
                  >
                    <el-col :md="14" :lg="14" :xl="14">
                      <el-input
                        v-model="form.yzcodes"
                        placeholder="请输入邮箱验证码"
                        @blur="DetectInput($event, 'codes')"
                        @input="DetectKey($event, 'codes')"
                      ></el-input>
                    </el-col>
                    <div class="clearfix"></div>
                    <div class="msg_error" v-html="ycodeTiShis"></div>
                  </el-form-item>

                  <div class="clearfix"></div>
                  <el-form-item label="原密码:" :rules="[{ required: true }]">
                    <el-col :md="14" :lg="14" :xl="14">
                      <el-input
                        v-model="form.oldPwd"
                        placeholder="请输入原密码"
                        @blur="DetectInput($event, 'opass')"
                        @input="DetectKey($event, 'opass')"
                        show-password
                      ></el-input>
                    </el-col>
                    <div class="clearfix"></div>
                    <div class="five highgray five" style="zoom: normal">
                      <span
                        >要更改密码，您必须先输入当前密码以验证您的身份。您也可以点击<router-link
                          to="/LookforPassword"
                          style="color: #428bca"
                          >“忘记密码”</router-link
                        >重置密码</span
                      >
                    </div>
                    <div class="msg_error" v-html="opwdTiShi"></div>
                  </el-form-item>
                  <el-form-item label="新密码:" :rules="[{ required: true }]">
                    <el-col :md="14" :lg="14" :xl="14">
                      <el-input
                        v-model="form.newPwd"
                        placeholder="请输入新密码"
                        @blur="DetectInput($event, 'pass')"
                        @input="DetectKey($event, 'pass')"
                        show-password
                      ></el-input>
                    </el-col>
                    <div class="clearfix"></div>
                    <div class="five highgray five" style="zoom: normal">
                      <span
                        >根据国家网络安全法要求，必须使用强密码（密码必须包含字母、数字、特殊字符3种形式；特殊字符仅包括.!@#_这5种西文字符；密码须8~16位）。</span
                      >
                    </div>
                    <div class="msg_error" v-html="pwdTiShi"></div>
                  </el-form-item>
                  <el-form-item label="确认密码:" :rules="[{ required: true }]">
                    <el-col :md="14" :lg="14" :xl="14">
                      <el-input
                        v-model="form.RePawd"
                        placeholder="请重新键入您的密码"
                        @blur="DetectInput($event, 'rpwd')"
                        @input="DetectKey($event, 'rpwd')"
                        show-password
                      ></el-input>
                    </el-col>
                    <div class="clearfix"></div>
                    <div class="five highgray five" style="zoom: normal">
                      <span>请确认您的新密码。</span>
                    </div>
                    <div class="msg_error" v-html="rpwdTiShi"></div>
                  </el-form-item>

                  <el-form-item label>
                    <el-button
                      style="width: 48%"
                      type="primary"
                      @click="submit()"
                      >提交</el-button
                    >
                    <el-button
                      style="width: 48%"
                      class="ml1"
                      @click="$router.push('/')"
                      >取消</el-button
                    >
                    <div class="highgreen ten" v-if="showsuess">
                      <i class="el-icon-success"></i>修改成功！
                    </div>
                  </el-form-item>
                </template>
              </div>
            </el-form>
            <div class="clearfix"></div>
            <div class="login_other fifth">
              <p class="text-center">
                没有账号?
                <a href="javascript:void(0)" @click="$router.push('/regist')"
                  >立即注册</a
                >
              </p>
              <p class="text-center">
                使用其他方式登录&nbsp;&nbsp;
                <a href="javascript:void(0)" @click="$router.push('/')"
                  >返回首页</a
                >
              </p>
              <p class="text-center" v-if="isweixin || IsQQLogin">
                已经有
                <span v-if="IsQQLogin">QQ，</span>
                <span v-if="isweixin">微信</span
                >账号，可直接登录，不用重复注册。
              </p>
              <div class="clearfix"></div>
              <div class="login_other_button">
                <!-- <div class="weixin" onclick="this.className = 'weixin on';"> -->
                <el-button
                  v-if="isweixin"
                  type="text"
                  @click="wxshow()"
                  class="weixin"
                >
                  <img src="../assets/images/add_wx1.png" />
                </el-button>
                <!-- <a href="javascript:;"><img   @mouseenter="wxshow()" src="../../assets/images/add_wx1.png"></a> -->
                <el-dialog
                  :visible.sync="dialogVisible"
                  width="30%"
                  center
                  :before-close="handleClose"
                >
                  <div v-loading="loading">
                    <p class="mobList eqcode">长按识别二维码注册并登录</p>
                    <p class="pclist eqcode">请用微信扫描二维码注册并登录</p>
                    <div>
                      <img :src="src" width="150" height="150" style />
                    </div>
                  </div>
                </el-dialog>
                <a
                  style="cursor: pointer"
                  @click="useqqlogin"
                  class="qq_login"
                  v-if="IsQQLogin"
                >
                  <img src="../assets/images/add_qq1.png" />
                </a>
              </div>
              <div class="clearfix"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="pwdFalseShow"
      width="27%"
      class="errDia"
      :before-close="handleClose"
      title="提示"
    >
      <div style="text-align: center">
        <p>
          您的密码不符合相关要求，请
          <router-link to="/ChangePassword" style="color: red"
            >点击此处</router-link
          >修改密码。
        </p>
      </div>
    </el-dialog>
    <el-dialog
      title="验证码验证"
      :visible.sync="isShow"
      custom-class="dialogwidth"
      :show-close="false"
    >
      <el-form @submit.native.prevent>
        <el-form-item>
          <el-col
            :xs="6"
            :sm="6"
            :md="6"
            :lg="6"
            :xl="6"
            style="text-align:right"
            >验证码:&nbsp;&nbsp;</el-col
          >
          <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
            <el-input v-model="yzcodesss" placeholder="请输入验证码"></el-input>
            <div class="msg_error" v-html="phoneTiShis"></div>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8" class="ml15">
            <span style="cursor: pointer">
              <div
                style="
                  height: 40px;
                  width: 110px;
                  font-size: 22px;
                  padding: 5px;
                "
              >
                <img
                  @click="initVeris()"
                  :src="'data:image/png;base64,' + Picturebases"
                  alt="无效"
                  style="height:40px; width:110px"
                />
              </div>
            </span>
          </el-col>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer" style="text-align:center">
        <el-button
          style="margin-top:10px;"
          type="primary"
          @click="bbb($event, 'name')"
          >确 定</el-button
        >
        <el-button @click="ccc">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
var timeStop;
var time;
import md5 from "js-md5";
import CryptoJS from "crypto-js";
export default {
  data() {
    return {
      guid: "",
      message: "",
      isEmailT: true,
      iscodeBtn: false,
      Btn: "发送验证码",
      codeTiShis: "",
      ycodeTiShis: "",
      picCodeTiShi: "",
      status: 0,
      EmailTiShi: "",
      pwdTiShi: "",
      opwdTiShi: "",
      rpwdTiShi: "",
      userTishi: "",
      showsuess: false,
      isweixin: false,
      wait: 60,
      codeTishi: "",
      Picture: "",
      Pictures: "",
      Picturebase: "",
      src: "",
      loading: true,
      pwdFalseShow: false,
      codeImg: require("../assets/images/timg.jpg"),
      Btn1: "发送邮箱验证码",
      iscodeBtna: true,
      dialogVisible: false,
      GUID: "",
      codeshow: true,
      form: {
        user: "",
        picyzcodes: "",
        yzcodes: "",
        emails: "",
        oldPwd: "",
        newPwd: "",
        RePawd: "",
      },
      GUIDS: "",
      isShow: false,
      isShows: false,
      isshuru: false,
      isshurus: true,
      ItemCounta: "",
      yzcodesss: "",
      phoneTiShis: "",
      Picturebases: "",
    };
  },

  async mounted() {
    this.initVeri();
    let params = [
      1000,
      1001,
      4530,
      6018,
      6019,
      230,
      6055,
      5000,
      5010,
      99,
      96,
      11,
      2960,
      4553,
      6021,
      310,
    ];
    this.$store.dispatch("_getSet", params).then((res) => {
      sessionStorage.setItem("SetItem", JSON.stringify(res.data.Data));
      let SetItem = res.data.Data;
      SetItem.map((item) => {
        if (item.SetItemID == 2960) {
          if (item.Item_Value == "是") {
            this.isweixin = true;
          } else {
            this.isweixin = false;
          }
        }
      });
    });
  },

  methods: {
    close() {
      window.close();
    },
    oninput() {},
    async wxshow() {
      this.dialogVisible = true;
      let carousel = await this.$store.dispatch("_getGetQrcode");
      if (carousel) {
        this.src = carousel.data.Url;
        this.Code = carousel.data.Code;
        this.loading = false;
        this.handleQrcodeCheck(this.type);
        this.$emit("func", this.src);
      }
    },
    handleQrcodeCheck(type) {
      timeStop = window.setInterval(() => {
        this.$store
          .dispatch("_getWeiXinLogin", { Scene: this.Code })
          .then((res) => {
            if (res.data.IsSuccess) {
              if (!res.data.Data.IsGo) {
                this.pwdFalseShow = true;
                return;
              }
              this.$message({ message: "登录成功", type: "success" });
              localStorage.setItem("userInfo", JSON.stringify(res.data.Data));
              var urldomain = "/";
              window.location.href = urldomain;
              this.$emit("fuab", false);
            }
          });
      }, 2000);
    },
    handleClose(done) {
      done();
      this.dialogVisible = false;
      clearInterval(timeStop);
    },
    useqqlogin() {
      var urldz =
        "https://graph.qq.com/oauth2.0/show?which=Login&display=pc&client_id=" +
        window.OpenId +
        "&response_type=token&scope=all&redirect_uri=" +
        window.callBackHtp +
        "%2F%23%2Flogin_qq";
      window.location.href = urldz;
    },
    timeCode(str) {
      //验证码时间定时器
      time = setInterval(() => {
        if (this.wait == 0) {
          this.Btn = "重新发送验证码";
          this.wait = 60;
          this.codess = false;
          clearInterval(time);
        } else {
          this.Btn = "验证码(" + this.wait + ")";
          this.wait--;
        }
      }, 1000);
    },
    DetectInput(elem, type) {
      //焦点离开时候的事件
      if (type == "emails") {
        if (this.$Bai(elem.target.value)) {
          return (this.EmailTiShi = "请输入邮箱");
        }
        if (this.$Space(elem.target.value)) {
          return (this.EmailTiShi = "邮箱不能含有空格");
        }

        if (!this.$base(elem.target.value, "email")) {
          return (this.EmailTiShi = "请输入正确格式的邮箱");
        } else {
          return (this.EmailTiShi = "");
        }
      }
      if (type == "Piccodes") {
        if (this.$Bai(elem.target.value)) {
          return (this.picCodeTiShi = "请输入图片验证码");
        } else {
          return (this.picCodeTiShi = "");
        }
      }

      if (type == "opass") {
        if (!elem.target.value || elem.target.value == "") {
          return (this.opwdTiShi = "原密码不能为空");
        } else {
          this.opwdTiShi = "";
        }
      }
      if (type == "pass") {
        if (!elem.target.value || elem.target.value == "") {
          return (this.pwdTiShi = "新密码不能为空");
        } else if (elem.target.value.length < 8) {
          return (this.pwdTiShi = "新密码不能小于八位字符");
        } else if (this.$Space(elem.target.value)) {
          return (this.pwdTiShi = "新密码不能含有空格");
        } else if (this.$base(elem.target.value, "aff")) {
          return (this.pwdTiShi = "新密码中含有非法字符");
        } else if (!this.$base(elem.target.value, "pass")) {
          return (this.pwdTiShi =
            "根据国家网络安全法要求，必须使用强密码（密码必须包含字母、数字、特殊字符3种形式；特殊字符仅包括.!@#_这5种西文字符；密码须8~16位）");
        } else {
          this.pwdTiShi = "";
        }
      }
      if (type == "rpwd") {
        if (elem.target.value == "" || !elem.target.value) {
          return (this.rpwdTiShi = "确认密码不能为空");
        } else if (elem.target.value.length < 8) {
          return (this.rpwdTiShi = "确认密码不得少于八位字符");
        } else if (this.$Space(elem.target.value)) {
          return (this.rpwdTiShi = "密码不能含有空格");
        } else if (this.form.pass != this.form.rpass) {
          return (this.rpwdTiShi = "两次输入密码不同");
        } else {
          this.rpwdTiShi = "";
        }
      }
      if (type == "user") {
        if (elem.target.value == "" || !elem.target.value) {
          this.userTishi = "用户名不能为空";
          return;
        } else {
          this.userTishi = "";
        }
      }
    },
    DetectKey(elem, type) {
      let base = this.base;
      if (type == "phone") {
        this.statuCf = false;
        this.statuCfa = false;
        return (this.phoneTiShi = "");
      } else if (type == "Piccodes") {
        this.statuCf = false;
        this.statuCfa = false;
        return (this.codeTiShi1 = "");
      } else if (type == "pwd") {
        this.statuCf = false;
        this.statuCfa = false;
        return (this.pwdTiShi = "");
      } else if (type == "rpwd") {
        this.statuCf = false;
        this.statuCfa = false;
        return (this.rpwdTiShi = "");
      } else {
        this.statuCf = false;
        this.statuCfa = false;
        return (this.EmailTiShi = "");
      }
    },
    async sendCodeBtn(elem, str) {
      let codes = this.form.picyzcodes;
      let Type = 0;
      if (this.form.user == "" || !this.form.user) {
        this.$message({
          showClose: true,
          message: "用户名不能为空",
          type: "error",
        });
        return;
      }
      if (this.$Bai(this.form.emails)) {
        this.$message({
          showClose: true,
          message: "邮箱不能为空",
          type: "error",
        });
        return;
      }
      if (codes == "" || codes == null || codes == undefined) {
        this.codeTiShis = "验证码不能为空";
        return;
      } else {
        if (codes.length < 6) {
          this.codeTiShis = "请输入正确的验证码";
          return;
        } else {
          this.codeTiShis = "";
        }
      }
      //验证码已经发送2分钟内不能重发送
      if (this.wait != 60) {
        return;
      }
      if (this.ItemCounta > 0) {
        this.$store
          .dispatch("_getRegSendCode", {
            MobileEmail: this.form.emails,
            CRCeMethod: 1,
            LookforPassword: true,
            VCode: this.form.picyzcodes,
            Guid: this.GUID,
            UserName: this.form.user,
          })
          .then((res) => {
            if (res.data.IsSuccess) {
              this.codeshow = false;
              this.codeTiShi = Type;
              this.iscodeBtna = false;
              this.status = 1;
              this.timeCode(elem.target);
              localStorage.setItem(
                "forgotStaTime",
                parseInt(new Date().getTime() / 1000)
              );
              localStorage.setItem("forgotStaTimeType", this.user_type);
              localStorage.setItem(
                "forgotTemporaryPhoneEmail",
                this.phoneAndEmail
              );
            } else {
              this.initVeri();
              this.$message({
                showClose: true,
                message: res.data.Message,
                type: "error",
              });
            }
          });
      }
    },
    submit() {
      let status = 0;
      if (this.status == 0) {
        return;
      }
      if (this.$Bai(this.form.yzcodes)) {
        status = 1;
        this.codeTiShi1 = "验证码不能为空";
      } else if (this.form.yzcodes.length < 6) {
        status = 1;
        this.codeTiShi1 = "请输入6位数的验证码";
      } else if (this.$base(this.form.yzcodes, "aff")) {
        status = 1;
        this.codeTiShi1 = "验证码中含有非法字符";
      }
      if (this.form.oldPwd == "" || !this.form.oldPwd) {
        status = 1;
        this.opwdTiShi = "原密码不能为空";
      }
      if (this.form.yzcodes == "" || !this.form.yzcodes) {
        status = 1;
        this.ycodeTiShis = "邮箱验证码不能为空";
      }
      if (this.form.newPwd == "" || !this.form.newPwd) {
        status = 1;
        this.pwdTiShi = "密码不能为空";
      } else if (this.form.newPwd.length < 8) {
        status = 1;
        this.pwdTiShi = "密码不能小于8位字符";
      } else if (this.$Space(this.form.newPwd)) {
        status = 1;
        this.pwdTiShi = "密码不能含有空格";
      } else if (this.$base(this.form.newPwd, "aff")) {
        status = 1;
        this.pwdTiShi = "密码中含有非法字符";
      } else if (!this.$base(this.form.newPwd, "pass")) {
        status = 1;
        this.pwdTiShi =
          "根据国家网络安全法要求，必须使用强密码（密码必须包含字母、数字、特殊字符3种形式；特殊字符仅包括.!@#_这5种西文字符；密码须8~16位）";
      }
      if (this.form.RePawd == "" || !this.form.RePawd) {
        status = 1;
        this.rpwdTiShi = "确认密码不能为空";
      } else if (this.form.RePawd.length < 8) {
        status = 1;
        this.rpwdTiShi = "确认密码不能小于8位字符";
      } else if (this.$Space(this.form.RePawd)) {
        status = 1;
        this.rpwdTiShi = "确认密码不能含有空格";
      } else if (this.$base(this.form.RePawd, "aff")) {
        status = 1;
        this.rpwdTiShi = "确认密码中含有非法字符";
      } else if (this.form.newPwd != this.form.RePawd) {
        status = 1;
        this.rpwdTiShi = "两次密码输入不一致";
      }
      if (status == 1) {
        return;
      }
      let Pwm = md5(this.form.oldPwd + "!@*Samson*@!");
      let npwm = md5(this.form.newPwd + "!@*Samson*@!");
      let opwaes = CryptoJS.AES.encrypt(this.form.oldPwd, Pwm).toString();
      let pwaes = CryptoJS.AES.encrypt(this.form.newPwd, npwm).toString();
      var data = {
        UserName: this.form.user,
        Email: this.form.emails,
        Password: opwaes,
        NewPassword: pwaes,
        EmailCode: this.form.yzcodes,
        Pwm: Pwm,
        Npwm: npwm,
      };
      this.$store.dispatch("_NoLoginChangePassword", data).then((res) => {
        if (res.data.IsSuccess) {
          localStorage.removeItem("userInfo");
          // this.$message({
          //   showClose: true,
          //   message: "修改密码成功，跳转中·······",
          //   duration:2000,
          //   type: "success"
          // });
          // setTimeout(() => this.$router.push("/Login"), 2500);
          localStorage.clear();
          alert("修改密码成功~~~");
          this.$router.push("/Login");
        } else {
          this.$message({
            showClose: true,
            message: res.data.Message,
            type: "error",
          });
          return;
        }
      });
    },
    //页面初始化形成验证码以及GUID
    async initVeri() {
      let resbase = await this.$store.dispatch("_getVerificationcodeImg");
      if (resbase.data.IsSuccess) {
        this.GUID = resbase.data.Data.GUID;
        this.Picturebase = resbase.data.Data.Picture;
      } else {
        console.log(resbase.data.Message);
      }
    },
    async aaa() {
      if (this.form.emails) {
        //0: Email 1:用户名 2: 手机
        this.Type = -1;
        if (this.$Bai(this.form.emails)) {
          this.$message({
            showClose: true,
            message: "邮箱或手机号不能为空",
            type: "error",
          });
          return;
        } else if (this.$base(this.form.emails, "phone")) {
          this.Type = 2;
        } else if (this.$base(this.form.emails, "email")) {
          this.Type = 0;
        } else {
          this.$message({
            showClose: true,
            message: "您的邮箱格式不对或者含有非法字符",
            type: "error",
          });
          return;
        }
        this.isShow = true;
        this.initVeris();
      }
    },
    async bbb() {
      if (
        this.yzcodesss == "" ||
        this.yzcodesss == null ||
        this.yzcodesss == undefined
      ) {
        this.phoneTiShis = "验证码不能为空";
        return;
      } else {
        if (this.yzcodesss.length < 6) {
          this.phoneTiShis = "请输入正确的验证码";
          return;
        } else {
          this.phoneTiShis = "";
        }
      }
      //验证码已经发送2分钟内不能重发送
      if (this.wait != 60) {
        return;
      }
      //验证email和手机是否注册过
      let res = await this.$store.dispatch("_getRegDeteCt", {
        Account: this.form.emails,
        Type: this.Type,
        Guid: this.GUIDS,
        VCode: this.yzcodesss,
      });
      if (res.data.IsSuccess == false) {
        this.phoneTiShis = res.data.Message;
        this.initVeris();
      } else {
        this.isShow = false;
        this.yzcodesss = "";
        this.phoneTiShis = "";
        this.ItemCounta = res.data.ItemCount;
        if (res.data.ItemCount >= 1) {
          this.isShows = true;
          this.isshurus = false;
        } else {
          this.$message({
            showClose: true,
            message: "您的邮箱还没有注册过，无法修改密码",
            type: "error",
          });
        }
      }
    },
    ccc() {
      this.isShow = false;
      this.yzcodesss = "";
      this.phoneTiShis = "";
    },
    async initVeris() {
      var random_number = Math.floor(Math.random() * (100 + 1));
      let resbase = await this.$store.dispatch("_getVerificationcodeImg");
      if (resbase.data.IsSuccess) {
        this.GUIDS = resbase.data.Data.GUID;
        this.Picturebases = resbase.data.Data.Picture;
      } else {
        console.log(resbase.data.Message);
      }
    },
  },
};
</script>

<style scoped>
.eqcode {
  font-size: 16px;
}
.Email_content {
  text-align: center;
}
.highgreen {
  color: #4d994d;
  line-height: 25px;
}
.highred {
  color: #d9534f;
}
::v-deep .dialogwidth {
  width: 22% !important;
}
@media screen and (max-width: 1400px) and (min-width: 768px) {
  ::v-deep .dialogwidth {
    width: 40% !important;
  }
}
@media screen and (max-width: 768px) and (min-width: 440px) {
  ::v-deep .dialogwidth {
    width: 60% !important;
  }
}
@media (max-width: 440px) {
  ::v-deep .dialogwidth {
    width: 80% !important;
  }
  .myzm {
    margin-left: 0 !important;
    margin-top: 10px;
  }
}
.el-dialog__footer {
  text-align: center !important;
}
.el-button--primary.is-plain {
  color: #fff;
}
</style>
